import { render, staticRenderFns } from "./MentionsLegales.vue?vue&type=template&id=3bd43264&"
import script from "./MentionsLegales.vue?vue&type=script&lang=js&"
export * from "./MentionsLegales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/felix/Google Drive/Travail/Mes projets/syl-vain/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
